module.exports = __webpack_public_path__ + "static/media/mack.142b028b.svg";